module.exports = __webpack_public_path__ + "img/john-mathidi.e5c97854.png";